/**
 * Knowledge-module access — PERMISSION-based, from assigned admin roles.
 *
 * This used to read `KnowledgeBase.Read`, and that was the bug: that scope is
 * RETRIEVAL, held by the Area Managers and Tech Services groups so the
 * assistant can search the knowledge base. It lit up the authoring UI for
 * everyone in those groups, who have no business editing guides.
 *
 * The split now: scopes govern data and agent tools, admin roles govern portal
 * surfaces. `permissions` comes from /api/me, resolved by the same code the
 * route guards use — and already filtered by the tenant's module entitlement,
 * so a tenant without the Knowledge Base module has none of these regardless of
 * who holds which role.
 */
import type { MeResponse } from './types.js';
import { PERMS } from './permissions.js';

type MeUser = MeResponse['user'];

const permissions = (user: MeUser): string[] => user.permissions ?? [];

export const canReadKnowledge = (user: MeUser): boolean =>
  permissions(user).includes(PERMS.knowledge.view);

export const canWriteKnowledge = (user: MeUser): boolean =>
  permissions(user).includes(PERMS.knowledge.manage);
